export default "__VITE_ASSET__181e6626__"